var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M27.889 32.124C22.734 35.732 14 34.911 14 34.911a14.041 14.041 0 004.554-3.266A9.459 9.459 0 0113 23.679c-.4-5.439 3.641-10.209 10.271-10.654C29.901 12.58 34.6 16.628 35 22.067a9.723 9.723 0 01-7.111 10.057zm-1.637-6.391l.819 2.254a.787.787 0 00.737.631c.39.01.765-.147 1.034-.429a.646.646 0 00.174-.456c0-.147-.028-.292-.081-.429l-3.287-9.044a1.866 1.866 0 00-1.891-1.328 1.827 1.827 0 00-1.852 1.328l-3.3 9.043a1.319 1.319 0 00-.08.443.605.605 0 00.187.443c.262.283.634.44 1.02.429a.809.809 0 00.751-.631l.819-2.254h4.95zm-2.8-5.876a.413.413 0 01.322-.362c.176.039.31.183.336.362l1.516 4.172h-3.7l1.526-4.172z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
